import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { EnhancedTableHead } from "../../../components/EnhancedTableHead";
import TableSkeleton from "../../../components/TableSkeleton";
import PinnedClubCards from "../PinnedClubCards";
import {
  setActiveClubDetail,
  setLicenceCriteria,
} from "../../../redux/reducers/evaluationDashboard";
import {
  getActiveClubEvaluationDetails,
  getLicenceCriteriaDetails,
} from "../../../api/evaluationDashboard";
import { TableCell, TableRow } from "@mui/material";
import { formatDate, getIconForValues, getStars } from "../Utils";
import StatusIndicatorSmall from "../../../components/StatusIndicatorSmall";
import ProgressBar from "../../../components/ProgressBar";

export default function MyLicencePage() {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const activeClubDetail: any = useSelector(
    (state: any) => state.evaluationDashboard.activeClubDetail
  );
  const licenceCriteriaDetail: any = useSelector(
    (state: any) => state.evaluationDashboard.licenceCriteria
  );
  const currentClub = useSelector((state: any) => state.clubDetails);
  const [order, setOrder] = React.useState("");
  const [orderBy, setOrderBy] = React.useState("");

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const peopleHead = [
    {
      key: "",
      displayName: t("ASM").toUpperCase(),
    },
    {
      key: "",
      displayName: t("LICENCE_TEAM").toUpperCase(),
    },
    {
      key: "",
      displayName: t("TRANSLATOR").toUpperCase(),
    },
    {
      key: "",
      displayName: t("DC_1_ACADEMY_DIRECTOR").toUpperCase(),
    },
  ];

  const Head2 = [
    {
      key: "",
      displayName: "",
    },
    {
      key: "",
      displayName: t("STATUS").toUpperCase(),
    },
    {
      key: "",
      displayName: t("DUE_DATE").toUpperCase(),
    },
  ];

  const Head3 = [
    {
      key: "",
      displayName: t("CRITERIA").toUpperCase(),
    },
    {
      key: "",
      displayName: t("STATUS").toUpperCase(),
    },
    {
      key: "",
      displayName: t("PROGRESS").toUpperCase(),
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      dispatch(
        setActiveClubDetail(
          await getActiveClubEvaluationDetails(currentClub.id)
        )
      );
      dispatch(
        setLicenceCriteria(await getLicenceCriteriaDetails(currentClub.id))
      );
    };
    if (currentClub.id !== 0) {
      dispatch(setActiveClubDetail(undefined));
      dispatch(setLicenceCriteria(undefined));
      fetchData();
    }
  }, [dispatch, currentClub]);
  return (
    <div>
      <PinnedClubCards />
      <>
        <TableContainer sx={{ height: "70%" }}>
          <Table
            stickyHeader
            sx={{ boxShadow: "none" }}
            size="small"
            aria-label="a dense table"
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              tableHeads={peopleHead}
              bg={"#fff"}
            />
            <TableBody>
              {activeClubDetail &&
              Object.entries(activeClubDetail).length > 0 ? (
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    "&:hover": {
                      backgroundColor: "#f5f5f5", // Light gray background on hover
                      cursor: "pointer", // Change cursor to pointer to indicate clickability
                    },
                  }}
                >
                  <TableCell
                    align="left"
                    style={{ fontSize: 12, fontFamily: "Montserrat" }}
                  >
                    {activeClubDetail.clubPeople?.asm || "-"}{" "}
                    {/* Display default if undefined */}
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{ fontSize: 12, fontFamily: "Montserrat" }}
                  >
                    {activeClubDetail.clubPeople?.evaluationTeam || "-"}{" "}
                    {/* Display default if undefined */}
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{ fontSize: 12, fontFamily: "Montserrat" }}
                  >
                    {activeClubDetail.clubPeople?.translator || "-"}{" "}
                    {/* Display default if undefined */}
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{ fontSize: 12, fontFamily: "Montserrat" }}
                  >
                    {activeClubDetail.clubPeople?.academyDirector || "-"}{" "}
                    {/* Display default if undefined */}
                  </TableCell>
                </TableRow>
              ) : (
                <TableSkeleton rowCount={1} cellCount={4} /> // Show skeleton loader if activeClubDetail is undefined
              )}
              <TableRow></TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </>
      <br />
      <Box sx={{ display: "flex", gap: "16px" }}>
        <>
          <TableContainer sx={{ height: "50vh" }}>
            <Table
              stickyHeader
              sx={{ boxShadow: "none" }}
              size="small"
              aria-label="a dense table"
            >
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                tableHeads={Head2}
                bg={"#fff"}
              />
              <TableBody>
                {activeClubDetail &&
                Object.entries(activeClubDetail).length > 0 ? (
                  <>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": {
                          backgroundColor: "#f5f5f5", // Light gray background on hover
                          cursor: "pointer", // Change cursor to pointer to indicate clickability
                        },
                      }}
                    >
                      <TableCell
                        style={{
                          fontSize: 12,
                          fontFamily: "Montserrat",
                          fontWeight: "bold",
                        }}
                      >
                        {t("SELF_ASSESSMENT")}
                      </TableCell>
                      <TableCell
                        style={{ fontSize: 12, fontFamily: "Montserrat" }}
                      >
                        {getIconForValues(activeClubDetail?.selfAssesment) ||
                          "-"}
                      </TableCell>
                      <TableCell
                        style={{ fontSize: 12, fontFamily: "Montserrat" }}
                      >
                        {formatDate(
                          activeClubDetail?.desirePlan?.dates
                            ?.selfAssessment1Date
                        ) || "-"}
                      </TableCell>
                    </TableRow>
                  </>
                ) : (
                  <TableSkeleton rowCount={5} cellCount={3} />
                )}
                <TableRow></TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </>
        <>
          <TableContainer sx={{ height: "50vh" }}>
            <Table
              stickyHeader
              sx={{ boxShadow: "none" }}
              size="small"
              aria-label="a dense table"
            >
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                tableHeads={Head3}
                bg={"#fff"}
              />
              <TableBody>
                {licenceCriteriaDetail && licenceCriteriaDetail.length > 0 ? (
                  licenceCriteriaDetail?.map((item: any) => {
                    return (
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          "&:hover": {
                            backgroundColor: "#f5f5f5", // Light gray background on hover
                            cursor: "pointer", // Change cursor to pointer to indicate clickability
                          },
                        }}
                      >
                        <TableCell
                          style={{ fontSize: 12, fontFamily: "Montserrat" }}
                        >
                          {item.name}
                        </TableCell>
                        <TableCell
                          style={{ fontSize: 12, fontFamily: "Montserrat" }}
                        >
                          <StatusIndicatorSmall
                            reportType={"rabg"}
                            status={item.status}
                          />
                        </TableCell>
                        <TableCell
                          style={{ fontSize: 12, fontFamily: "Montserrat" }}
                        >
                          <ProgressBar percent={item.progress} />
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableSkeleton rowCount={5} cellCount={3} />
                )}
                <TableRow></TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </>
      </Box>
    </div>
  );
}
